import {
  fetchConsumeList,
  fetchReportList,
  fetchTitleList,
  getWarnningCount,
} from '@/api/dashboard/dashboard';
import customerData from './CustomerData/CustomerDataStore';
import customerRecharge from './CustomerRecharge/CustomerRechargeStore';
// import customerConsumption from './CustomerConsumption/CustomerConsumptionStore';
import customerFeedback from './CustomerFeedback/CustomerFeedbackStore';
import initFiltersStore from '@/store/modules/filters';
import { getFilters, formatDate } from '@/utils/index';

const GET_CONSUME_DATA = 'GET_CONSUME_DATA';
const GET_REPORT_DATA = 'GET_REPORT_DATA';
const GET_TITLE_DATA = 'GET_TITLE_DATA';
const GET_PERCENT_DATA = 'GET_PERCENT_DATA';
const GET_EUIPMENT_DATA = 'GET_EUIPMENT_DATA';
const GET_CAMPUS_DATA = 'GET_CAMPUS_DATA';
const UPDATE_SERVICE_NAME = 'UPDATE_SERVICE_NAME';
const LOADING_AREA = 'LOADING_AREA';
const LOADING_SERVICE = 'LOADING_SERVICE';
const LOADING_EQUIPMENT = 'LOADING_EQUIPMENT';
const LOADING_REGIST = 'LOADING_REGIST';
const LOADING_REGIST_BY_DAY = 'LOADING_REGIST_BY_DAY';
const GET_WARNNING_COUNT = 'GET_WARNNING_COUNT';

const initFilters = () => ({
  operateId: undefined,
  choiceareaIds: [],
  timeType: 0, // 0 本日，1 本月， 2 本年
  reportYear: new Date().getFullYear().toString(),
  reportAreaId: undefined,
});
const filtersStore = initFiltersStore(initFilters);
const nowTime = new Date();

const state = () => ({
  loading: {
    area: false,
    service: false,
    equipment: false,
    regist: false,
    registByDay: false,
  },
  consume: {
    areaInfo: {
      areaName: '',
      areaId: undefined,
    },
    serviceInfo: {
      serviceName: '',
    },
    consumeAfterVos: [],
    consumeHardVos: [],
    list: [],
    percentList: [],
  },
  report: {
    mounted: false,
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    registePerDay: [],
    registePerMonth: [],
    activeUser: [],
    customerCount: 0,
    activeCount: 0,
  },
  title: {
    activeCount: 0,
    countArea: 0,
    countCustomer: 0,
    warnningCount: 0,
  },
});

const getters = {
  reportMounted: state => state.report.mounted,
  reportYear: state => state.report.year,
  reportMonth: state => state.report.month,
  registePerDay: state => state.report.registePerDay,
  registePerMonth: state => state.report.registePerMonth,
  registeTotal: state => state.report.customerCount,
  activeTotal: state => state.report.activeCount,
  activeUser: state => state.report.activeUser,
  titleData: state => state.title,
  areaInfo: state => state.consume.areaInfo,
  consumeAfterVos: state => state.consume.consumeAfterVos,
  consumeHardVos: state => state.consume.consumeHardVos,
  campusRankList: state => {
    return state.consume.list.filter(item => {
      return state.filtersStore.filters.choiceareaIds.indexOf(item.areaId) > -1;
    });
  },
  seviceRatioList: state => state.consume.percentList,
  consumeServiceInfo: state => state.consume.serviceInfo,
  loading: state => state.loading,
};

const actions = {
  fetchConsumeList({ commit, getters, dispatch }, data) {
    let entity = getFilters(getters.filters);
    switch (entity.timeType) {
      case 1:
        entity.month = formatDate(nowTime, 'yyyy-MM');
        break;
      case 2:
        entity.year = formatDate(nowTime, 'yyyy');
        break;
      case 0:
      default:
        entity.date = formatDate(nowTime, 'yyyy-MM-dd');
        break;
    }
    if (data && data.updatePercentList) {
      entity.areaId = data.areaId;
      commit(LOADING_SERVICE, true);
    } else if (data && data.updateEuipmentList) {
      entity.serviceId = data.serviceId;
      entity.areaId = getters.areaInfo.areaId;
      commit(LOADING_EQUIPMENT, true);
    } else {
      commit(LOADING_AREA, true);
    }

    return fetchConsumeList({
      data: {
        ...entity,
      },
    })
      .then(res => {
        let list = res.data;
        if (list.percentList && list.percentList.length) {
          commit(UPDATE_SERVICE_NAME, list.percentList[0].serviceName);
        }
        if (data && data.updatePercentList) {
          commit(GET_PERCENT_DATA, list);
          commit(GET_EUIPMENT_DATA, list);
          commit(LOADING_SERVICE, false);
        } else if (data && data.updateEuipmentList) {
          commit(GET_EUIPMENT_DATA, list);
          commit(UPDATE_SERVICE_NAME, data.serviceName);
          commit(LOADING_EQUIPMENT, false);
        } else {
          if (entity && entity.choiceareaIds) {
          } else if (list.list && list.list.length > 5) {
            let areaList = list.list.slice(0, 5);
            dispatch('updateFilters', {
              choiceareaIds: areaList.map(item => item.areaId),
            });
          } else if (list.list) {
            dispatch('updateFilters', {
              choiceareaIds: list.list.map(item => item.areaId),
            });
          }

          commit(GET_CONSUME_DATA, list);
          commit(LOADING_AREA, false);
        }
      })
      .catch(err => {
        console.error(err);
        commit(LOADING_AREA, false);
      });
  },
  fetchReportList({ commit, getters }, entity) {
    let filters = getFilters(getters.filters);
    if (filters.reportYear) {
      entity.year = filters.reportYear;
    }
    if (filters.reportAreaId) {
      entity.areaId = filters.reportAreaId;
    }
    if (entity && entity.updateRegisteByDay) {
      commit(LOADING_REGIST_BY_DAY, true);
    } else {
      commit(LOADING_REGIST, true);
    }
    return fetchReportList({
      params: {
        ...entity,
      },
    })
      .then(res => {
        let list = res.data;
        commit(GET_REPORT_DATA, list);
        if (entity && entity.updateRegisteByDay) {
          commit(LOADING_REGIST_BY_DAY, false);
        } else {
          commit(LOADING_REGIST, false);
        }
      })
      .catch(err => {
        console.error(err);
        if (entity && entity.updateRegisteByDay) {
          commit(LOADING_REGIST_BY_DAY, false);
        } else {
          commit(LOADING_REGIST, false);
        }
      });
  },
  fetchTitleList({ commit }) {
    return fetchTitleList().then(res => {
      let data = res.data;
      commit(GET_TITLE_DATA, data);
    });
  },
  getWarnningCount({ commit }) {
    getWarnningCount().then(res => {
      commit(GET_WARNNING_COUNT, res.data);
    });
  },
  updateCampusName({ commit }, data) {
    if (data) {
      commit(GET_CAMPUS_DATA, data);
    } else {
      commit(GET_CAMPUS_DATA, {
        areaId: undefined,
        areaName: '',
      });
    }
  },
};

const mutations = {
  [GET_CONSUME_DATA]: (state, data) => {
    state.consume.consumeHardVos = data.consumeHardVos
      ? data.consumeHardVos
      : [];
    state.consume.consumeAfterVos = data.consumeAfterVos
      ? data.consumeAfterVos
      : [];
    state.consume.list = data.list ? data.list : [];
    state.consume.percentList = data.percentList ? data.percentList : [];
  },
  [GET_PERCENT_DATA]: (state, data) => {
    state.consume.percentList = data.percentList;
  },
  [GET_EUIPMENT_DATA]: (state, data) => {
    state.consume.consumeHardVos = data.consumeHardVos
      ? data.consumeHardVos
      : [];
    state.consume.consumeAfterVos = data.consumeAfterVos
      ? data.consumeAfterVos
      : [];
  },
  [GET_REPORT_DATA]: (state, data) => {
    state.report.customerCount = data.customerCount ? data.customerCount : 0;
    state.report.activeCount = data.activeCount ? data.activeCount : 0;

    state.report.year = data.year;
    state.report.month = data.month;

    let dayList = new Array(31).fill({ count: 0 });
    dayList = dayList.map((v, idx) => ({ ...v, days: idx + 1 }));
    data.dayVos.map(val => {
      let idx = Number(val.days.substr(-2)) - 1;
      dayList[idx].count = val.count;
    });
    state.report.registePerDay = dayList;

    let registerList = new Array(12)
      .fill({ count: 0, mark: null })
      .map((v, idx) => ({ ...v, month: (idx + 1).toString() }));
    data.list.map(val => {
      let idx = val.month - 1;
      registerList[idx].count += val.count;
    });
    state.report.registePerMonth = registerList;

    let activeList = new Array(12)
      .fill({ count: 0, mark: 'allActive' })
      .map((v, idx) => ({ ...v, month: (idx + 1).toString() }));
    let activeAppList = new Array(12)
      .fill({ count: 0, mark: 'monthAppActive' })
      .map((v, idx) => ({ ...v, month: (idx + 1).toString() }));
    let activeDeviceList = new Array(12)
      .fill({ count: 0, mark: 'monthHardActive' })
      .map((v, idx) => ({ ...v, month: (idx + 1).toString() }));
    data.listCount.map(val => {
      let idx = val.month - 1;
      if (val.mark === 'allActive') {
        activeList[idx].count += val.count;
      }
      if (val.mark === 'monthAppActive') {
        activeAppList[idx].count += val.count;
      }
      if (val.mark === 'monthHardActive') {
        activeDeviceList[idx].count += val.count;
      }
    });
    activeList.push.apply(activeList, activeAppList);
    activeList.push.apply(activeList, activeDeviceList);
    state.report.activeUser = activeList;
  },
  [GET_TITLE_DATA](state, data) {
    state.title.activeCount = data.activeCount;
    state.title.countArea = data.countArea;
    state.title.countCustomer = data.countCustomer;
  },
  [GET_WARNNING_COUNT](state, count) {
    state.title.warnningCount = count;
  },
  [GET_CAMPUS_DATA](state, name) {
    state.consume.areaInfo = name;
  },
  [UPDATE_SERVICE_NAME](state, name) {
    state.consume.serviceInfo = {
      serviceName: name,
    };
  },
  [LOADING_AREA](state, fetching) {
    state.loading.area = fetching;
    state.loading.service = fetching;
    state.loading.equipment = fetching;
  },
  [LOADING_SERVICE](state, fetching) {
    state.loading.service = fetching;
    state.loading.equipment = fetching;
  },
  [LOADING_EQUIPMENT](state, fetching) {
    state.loading.equipment = fetching;
  },
  [LOADING_REGIST](state, fetching) {
    if (fetching) {
      state.report.mounted = true;
    }
    state.loading.regist = fetching;
  },
  [LOADING_REGIST_BY_DAY](state, fetching) {
    state.loading.registByDay = fetching;
  },
};

export default {
  namespaced: true,
  modules: {
    filtersStore,
    customerData,
    customerRecharge,
    // customerConsumption,
    customerFeedback,
  },
  state,
  getters,
  actions,
  mutations,
};
